define('presentation/welcome/facades/onboardingInProgressFacade',[
    'common/promises/promiseFactory',
    'common/storage/commonState',
    'persistence/repositories/liveReceptionistOnboardingRepository',
], function() {
    return function() {
        let self = this;

        let _liveReceptionistOnboardingRepository = null;
        let _promiseFactory = null;

        const _onLiveReceptionistOnboardingCompleted = (callback) => {
            _liveReceptionistOnboardingRepository.onLiveReceptionistOnboardingCompleted((event) => {
                callback(event);
            });
        };

        const _dispose = () => {
            _liveReceptionistOnboardingRepository.dispose();
        };

        const _init = (promiseFactory) => {
            _promiseFactory = promiseFactory;

            const LiveReceptionistOnboardingRepository = require('persistence/repositories/liveReceptionistOnboardingRepository');
            _liveReceptionistOnboardingRepository = new LiveReceptionistOnboardingRepository();
        };

        self.init = _init;
        self.onLiveReceptionistOnboardingCompleted = _onLiveReceptionistOnboardingCompleted;
        self.dispose = _dispose;
    };
});

